import React, { useEffect, useState } from 'react';
import { ANIMATION_DELAY } from './constants';
import { formatDate, formatLocation } from '../../../../lib/utils/utils';

function Scan({ 
    instruction, 
    date, 
    location, 
    destination, 
    index, 
    isActive, 
    lastNotDelivered, 
    isLast, 
    isGreen = true ,
    isSecondLast = false
}) {
    const [scanHeight, setScanHeight] = useState('h-0');

    useEffect(() => {
        const timer = setTimeout(() => {
            setScanHeight('h-14');
        }, ANIMATION_DELAY * index);

        return () => clearTimeout(timer);
    }, [index]);

    // Determine circle styles based on state
    const getCircleStyles = () => {
        const baseStyles = 'w-6 h-6 relative z-5 rounded-full border-2';
        const animationStyles = isActive && lastNotDelivered ? 'border-dashed animate-spin-slow' : '';
        const colorStyles = isGreen ? 'border-primaryColor' : 'border-[#D1D5DB]';
        
        return `${baseStyles} ${animationStyles} ${colorStyles}`;
    };

    // Determine inner dot styles
    const getDotStyles = () => {
        const baseStyles = 'w-3 h-3 absolute transform top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 rounded-full';
        const colorStyles = isGreen ? 'bg-primaryColor' : 'bg-[#D1D5DB]';
        
        return `${baseStyles} ${colorStyles}`;
    };

    // Determine line styles
    const getLineStyles = () => {
        const baseStyles = `absolute left-1/2 -translate-x-1/2 w-1 ${scanHeight} transition-height duration-700 ease-in`;

        // Only second last scan gets gray line
        const colorStyles = isSecondLast
            ? 'bg-[#D1D5DB]'
            : 'bg-primaryColor';

        return `${baseStyles} ${colorStyles}`;
    };

    const shouldShowLine = !isLast || lastNotDelivered;

    return (
        <div className="relative" role="listitem">
            <div 
                className={getCircleStyles()}
                aria-current={isActive ? 'step' : undefined}
            >
                <div className={getDotStyles()}></div>
            </div>

            <div className="absolute top-[-1px] left-9 flex flex-col text-[#121212]">
                <h1 className='font-semibold text-[14px] leading-[26px] whitespace-nowrap'>
                    {instruction}
                </h1>
                {location && (
                    <h2 className='font-medium text-[12px] leading-5 whitespace-nowrap text-gray-600'>
                        {formatLocation(location)}
                    </h2>
                )}
                {destination && (
                    <h2 className='font-medium text-[12px] leading-5 whitespace-nowrap text-gray-600'>
                        {destination}
                    </h2>
                )}
                {date && (
                    <h2 className='font-medium text-[12px] leading-5 whitespace-nowrap text-gray-500'>
                        {formatDate(date)}
                    </h2>
                )}
            </div>

            {shouldShowLine && (
                <div className={getLineStyles()} aria-hidden="true"></div>
            )}
        </div>
    );
}

export default React.memo(Scan);
